import { render, staticRenderFns } from "./project-detail-left-nav.vue?vue&type=template&id=dd19c904&"
import script from "./project-detail-left-nav.vue?vue&type=script&lang=ts&"
export * from "./project-detail-left-nav.vue?vue&type=script&lang=ts&"
import style0 from "./project-detail-left-nav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports